import React from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import PropTypes from "prop-types";

import SqftFeaturesPopupFeature from "./sqftFeaturesPopupFeature";
import SqftFeaturesPopupParentListTitle from "./sqftFeaturesPopupParentListTitle";

const SqftFeaturesPopupParentList = (props) => {

  const {parentsList, parentsLists, rebuildQuoteLists, setParentsLists} = props;

  if (!parentsList) {
    return null
  }

  return (
    <div className="ui-popup__body-parentlist">
      {Object.keys(parentsList).map(parentKey => {
        const parent = parentsList[parentKey];
        if (!parent || !parent.features || !parent.features.length) {
          return null
        }

        return (
          <div className="sqft-popup__group" key={parentKey}>
            <SqftFeaturesPopupParentListTitle parentsList={parentsList}
                                              parentKey={parentKey}
                                              parentsLists={parentsLists}
                                              setParentsLists={setParentsLists}
                                              rebuildQuoteLists={rebuildQuoteLists} />
            <ul className="sqft-popup__list">
              {parent.features.map((sqftFeature, sqftFeatureIndex) => (
                <SqftFeaturesPopupFeature key={"sqftFeature" + sqftFeatureIndex}
                                          parentKey={parentKey}
                                          parentsList={parentsList}
                                          parentsLists={parentsLists}
                                          setParentsLists={setParentsLists}
                                          sqftFeatureIndex={sqftFeatureIndex}
                                          rebuildQuoteLists = { rebuildQuoteLists }/>
              ))}
            </ul>
          </div>
        )
      })}
    </div>
  )
};

SqftFeaturesPopupParentList.propTypes = {
  parentsList: PropTypes.object,
  parentsLists: PropTypes.array,
  setParentsLists: PropTypes.func.isRequired,
  rebuildQuoteLists: PropTypes.func,
}

const mapStateToProps = (store) => {
  return {
    fabricatorData: store.fabricatorState
  };
};
const mapDispatchToProps = {};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftFeaturesPopupParentList)
)
